var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.87 26.75a2.25 2.25 0 10-3.741-2.5 2.25 2.25 0 003.742 2.5zM8.5 12c0-3.722 3.364-6.75 7.5-6.75s7.5 3.028 7.5 6.75c0 3.259-2.58 5.987-6 6.615v.135a1.5 1.5 0 11-3 0v-1.5a1.5 1.5 0 011.5-1.5c2.48 0 4.5-1.688 4.5-3.75 0-2.063-2.02-3.75-4.5-3.75S11.5 9.938 11.5 12v.75a1.5 1.5 0 11-3 0V12z"
  })));
}
export default SvgQuestionMarkRegular;